<div
	class="step"
	[ngClass]="{
		'is--active': (currentStep$ | async)! >= step,
		'is--completed': (currentStep$ | async)! > step
	}"
	[attr.aria-label]="ariaLabel"
	[attr.data-quat]="'value_workflowStep' + step"
></div>
